<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{data.title}}</h3>
    </div>
  </div>
  <form [formGroup]="form" class="form">
    <div class="card-body">
      <div class="row">
        <div class="col-lg-12 kt-margin-bottom-20-mobile">
          <mat-form-field class="mat-form-field-fluid">
            <input matInput [placeholder]="data.placeholder" formControlName="name" />
            <mat-error>
              {{data.placeholder}}
              <strong>required</strong>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-lg-12 kt-margin-bottom-20-mobile" *ngIf="data.descriptionPlaceholder">
          <mat-form-field class="mat-form-field-fluid">
            <textarea matInput rows="3" [placeholder]="data.descriptionPlaceholder" formControlName="description"></textarea>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="card-footer p-0 b-0">
      <div class="form-actions form-actions-solid">
        <div class="row text-right">
          <div class="col-lg-12">
            <button type="button" mat-raised-button cdkFocusInitial (click)="onClose()">
              Close
            </button>&nbsp;
            <button type="button" class="btn btn-success" mat-raised-button color="submit" (click)="onSubmit()">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
